<template>
  <div class="campaign-banner">
    <div class="container">
      <div class="flex-box" :class="maxWidth">
        <div class="left-container">
          <h3>{{ banner.detail.name }}</h3>
          <rz-markdown v-if="banner.detail && banner.detail.desc" class="banner-content"
          :text="banner.detail.desc"></rz-markdown>
          <div class="form-container">
            <input
              type="email"
              v-model="workEmail"
              placeholder="Enter your work email"
              @keyup.enter="openContactPopup"
            />
            <button class="rs-button blue-cta" @click="openContactPopup">
              Start free trial
            </button>
            <ContactComponent
              v-if="showContactPopup"
              :email="workEmail"
              :showContactPopup="showContactPopup"
              @update:showContactPopup="showContactPopup = $event"
            />
          </div>
          <div class="marquee">
            <div class="marquee-content">
              <ul class="list-inline">
                <template v-for="i in [1, 2, 3, 4, 5]">
                  <li v-for="n in [1, 2, 3, 4, 5]" :key="`${i}-${n}`">
                    <img  :src="getClientLogoPath(n)"
                      alt="Client Logo" />
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="right-container" :class="maxWidth">
          <div class="image-wrap" :class="maxWidth">
            <rz-image-item
              v-if="banner.detail.img" :image="banner.detail.img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.campaign-banner {
  .left-container {
    .markdown {
      .p {
        color:#5F5F5F;
        font-size: size(16);
        font-weight: 400;
        line-height: size(24);
        max-width: 100%;
        padding-bottom: size(20);
        @media screen and (min-width:  $breakpoint-md) {
          max-width: size(300);
          padding-bottom: size(30);
        }
        @media screen and (min-width:  $breakpoint-lg) {
          max-width: size(620);
        }
        a {
          color: var(--hero-text);
        }
        strong {
          font-weight: bold;
        }
      }
      h1 {
        color: var(--rz-title-color);
        font-size: size(32);
        font-weight: 800;
        line-height: size(44);
        margin-bottom: size(20);
        @media screen and (min-width:  $breakpoint-md) {
          font-size: size(42);
          line-height: size(56);
        }
        @media screen and (min-width:  $breakpoint-lg) {
          font-size: size(78);
          line-height: size(84);
          margin-bottom: size(30);
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.campaign-banner {
  background: url('../../assets/campaign/bg_grid.svg') no-repeat;
  background-size: 100%;
  .container {
    margin: 0 auto;
    // max-width: size(320);
    // padding: size(0) size(20);

    @media screen and (min-width: $breakpoint-md) {
      max-width: size(700);
      padding: size(0) size(20);
    }

    @media screen and (min-width: $breakpoint-lg) {
      max-width: size(1200);
      padding: 0 size(120);
    }
    .flex-box {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: size(20);
      @media screen and (min-width: $breakpoint-md) {
        flex-direction: row;
        gap: size(40);
      }
      .left-container {
        max-width: 100%;
        color: var(--rs-black-color);
        padding: size(120) size(20) 0;
        max-width: size(320);
        @media screen and (min-width:  $breakpoint-md) {
          padding-bottom: size(60);
          padding-left: 0;
          padding-right: 0;
          max-width: size(420);
        }
        @media screen and (min-width:  $breakpoint-lg) {
          padding-top: size(150);
          max-width: size(735);
          padding-bottom: 0;
        }
        h3 {
          font-size: size(16);
          font-weight: 700;
          letter-spacing: size(1.6);
          text-transform: uppercase;
          margin-bottom: size(6);
        }
        .marquee {
          margin: 0 auto;
          width: 100%;
          height: size(60);
          white-space: nowrap;
          overflow: hidden;
          @media screen and (min-width:  $breakpoint-lg) {
            padding-bottom: size(90);
          }
        }

        .marquee-content {
          width: 100%;
          display: flex;
          animation: marquee 10s linear infinite forwards;
          &:hover {
            animation-play-state: paused;
          }
          img {
            max-height: size(80);
            @media screen and (min-width: $breakpoint-lg) {
              max-height: size(130);
            }
          }
        }

        .list-inline {
          display: flex;
          justify-content: center;
          align-items: center;
          list-style: none;
          margin: 0;
          flex-shrink: 0;
          width: 100%;
          gap: size(20);
        }
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media screen and (min-width:  $breakpoint-md) {
          .list-inline {
            width: 50%;
            gap: size(30);
          }
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-300%); }
          }
        }
        @media screen and (min-width:  $breakpoint-lg) {
          gap: size(60);
          width: 50%;
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
        }

        .form-container {
          display: flex;
          align-content: center;
          justify-content: space-between;
          gap: size(12);
          white-space: nowrap;
          padding-bottom: size(30);
          @media screen and (min-width: $breakpoint-lg) {
            gap: size(30);
            padding-bottom: 0;
          }
          input {
            border-radius: size(5);
            border: 1px solid #C0C0C0;
            outline: none;
            background: #FFF;
            color: var(--rs-black-color);
            font-size: size(15);
            font-weight: 300;
            width: 50%;
            padding: size(8) size(10);
            @media screen and (min-width: $breakpoint-md) {
              width: 56%;
            }
            @media screen and (min-width: $breakpoint-lg) {
              width: 100%;
              padding: size(20) size(30);
            }
            &::placeholder {
              color: #8D8D8D;
            }
          }
          .rs-button {
            font-size: size(12);
            line-height: size(14);
            font-weight: bold;
            padding: size(8) size(12);
            display: inline-block;
            background: var(--rs-cta-blue-color);
            border: size(1) solid var(--rs-cta-blue-color);
            border-radius: size(6);
            color: var(--rs-white-color);
            cursor: pointer;
            @media screen and (min-width: $breakpoint-md) {
              font-size: size(14);
              line-height: size(16);
            }
            @media screen and (min-width: $breakpoint-lg) {
              padding: size(14) size(24);
            }
            &:hover {
              &:after {
                @include move-animation;
              }
            }
            &:after {
              content: '';
              border-width: 0 size(2) size(2) 0;
              display: inline-block;
              padding: size(2.2);
              transform: rotate(-45deg);
              -webkit-transform: rotate(-45deg);
              margin-left: size(5);
              vertical-align: middle;
              border: solid var(--rs-white-color);
              border-width: 0 size(2) size(2) 0;
            }
          }
        }
      }
      .right-container {
        width: 100%;
        @media screen and (min-width: $breakpoint-md) {
          width: size(300);
          padding-top: size(70);
        }
        @media screen and (min-width: $breakpoint-lg) {
          width: size(475);
        }
        .image-wrap {
          height: size(300);
          @media screen and (min-width: $breakpoint-md) {
            height: size(400);
          }
          @media screen and (min-width: $breakpoint-lg) {
            height: size(835);
          }
        }
      }
    }
  }
}
</style>
<script>
import clientLogo1 from '@/assets/campaign/client_logo_1.svg';
import clientLogo2 from '@/assets/campaign/client_logo_2.svg';
import clientLogo3 from '@/assets/campaign/client_logo_3.svg';
import clientLogo4 from '@/assets/campaign/client_logo_4.svg';
import clientLogo5 from '@/assets/campaign/client_logo_5.svg';
import ContactComponent from '../../views/RZWebsite/ContactComponent.vue';


export default {
  components: {
    ContactComponent,
  },
  props: {
    banner: {
      type: Object,
    },
    maxWidth: {
      type: String,
    },
  },
  data() {
    return {
      clientLogos: [
        clientLogo1,
        clientLogo2,
        clientLogo3,
        clientLogo4,
        clientLogo5,
      ],
      showContactPopup: false,
      workEmail: '',
    };
  },
  methods: {
    getClientLogoPath(n) {
      return this.clientLogos[n - 1];
    },
    setContactPopup(val) {
      this.showContactPopup = val;
    },
    openContactPopup() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.workEmail.trim() !== '' && emailRegex.test(this.workEmail)) {
        this.showContactPopup = true;
      } else {
        window.alert('Please enter a valid work email address.');
      }
    },
  },
};
</script>
